import find from 'lodash/find';
import flattenDeep from 'lodash/flattenDeep';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import some from 'lodash/some';
import {APIRegistry} from '@spothero/utils/api';
import {getStore} from 'store/store';
import {getSpots} from 'spots/spots-selectors';
import Config from 'config';

const updateSpots = (data, spots, destinations, isDriving) => {
    let i = 0;
    let spot;

    for (i; i < data.length; i++) {
        if (data.status !== 'NO_DATA' && !isEmpty(data[i].distance) && !isEmpty(data[i].duration)) {
            destinations[i].distanceInMiles = `${(data[i].distance / 5280).toFixed(2)} mi`;
            destinations[i].durationInSeconds = data[i].duration;
        } else {
            destinations.splice(i, 1);
        }
    }

    forEach(destinations, destination => {
        spot = find(spots, {parking_spot_id: destination.spotId}); // eslint-disable-line camelcase

        if (spot) {
            spot.distanceInMiles = destination.distanceInMiles;

            if (isDriving) {
                spot.drivingDuration = destination.durationInSeconds;
            } else {
                spot.walkingDuration = destination.durationInSeconds;
            }

            spot.hasTravelDistanceUpdated = true;
        }
    });

    return spots;
};

const makePromise = (spots, origin, destinations, isDriving) => {
    const travelMode = (isDriving) ? 'DRIVING' : 'WALKING';
    const destinationLatLngs = flattenDeep(map(destinations, destination => {
        return destination.latlng;
    }), latlng => {
        return latlng;
    });
    const destParams = destinationLatLngs.join('&destinations=');
    const url = `/distance/v1/distance/?origins=${origin}&unitSystem=IMPERIAL&travelMode=${travelMode}&destinations=${destParams}`;
    const ServiceAPIUtil = APIRegistry.get('services');

    return new Promise((resolve, reject) => {
        ServiceAPIUtil
            .get(url, {}, {
                baseURL: Config.serviceAPIUrl,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(({
                data: {
                    data
                }
            }) => {
                resolve(updateSpots(data, spots, destinations, isDriving));
            })
            .catch(response => {
                reject(new Error(`No results returned from the Distance Matrix Service. Response: "${response}".`));
            });
    });
};

export const retrieveSpotTravelDistance = spot => {
    const spots = [spot];
    const {
        searchRequest: {
            latitude,
            longitude
        }
    } = getStore().getState();
    const origin = `${latitude},${longitude}`;
    const isDriving = some(spot.selectedRate.amenities, {slug: 'shuttle'});
    const destinations = [
        {
            latlng: `${spot.wd_latitude},${spot.wd_longitude}`,
            spotId: spot.parking_spot_id
        }
    ];

    return makePromise(spots, origin, destinations, isDriving);
};

export const retrieveTravelDistances = (limit = 10) => {
    const storeState = getStore().getState();
    const spots = getSpots(storeState);
    const {
        searchRequest: {
            latitude,
            longitude
        }
    } = storeState;
    const origin = `${latitude},${longitude}`;
    const walkingDestinations = [];
    const drivingDestinations = [];
    const requests = [];
    let counter = 0;

    forEach(spots, spot => {
        if (counter < limit && !spot.hasTravelDistanceUpdated) {
            const selectedArray = (some(spot.selectedRate.amenities, {slug: 'shuttle'}))
                ? drivingDestinations
                : walkingDestinations;

            selectedArray.push({
                latlng: `${spot.wd_latitude},${spot.wd_longitude}`,
                spotId: spot.parking_spot_id
            });

            counter++;
        }
    });

    if (walkingDestinations.length) {
        requests.push(makePromise(spots, origin, walkingDestinations));
    }

    if (drivingDestinations.length) {
        requests.push(makePromise(spots, origin, drivingDestinations, true));
    }

    return requests;
};
